import Helper from './Helper';

class Video {
  constructor() {

    const playbutton = Array.from(document.querySelectorAll('.lc-video--youtube .lc-video__thumbnail'));
    playbutton.forEach(button =>{
      button.addEventListener('click', () => {
        const video = button.parentElement;
        const thumbnail = button;
        const iframe = video.querySelector('iframe');
        iframe.src = iframe.src + '?autoplay=1';
        thumbnail.classList.add('fade-out');
        thumbnail.style.display = 'none';
      });
    });

    const bgVideo = [...document.querySelectorAll('.ns-header-img__video-wrapper video')];

    window.addEventListener("scroll", e => {
      let scrollTop = document.documentElement.scrollTop;
      bgVideo.forEach(video => {
        // console.log(video);
        const elHeight = video.offsetHeight/2;
        if(scrollTop <= elHeight || scrollTop == 0){
          if(video.paused){
            video.play();
          }
        } else {
          video.pause();
        }
      });
    });
  }
} export default Video;
